/**
 * Re:do returns badge — opens and closes the info popup.
 *
 * The popup is a native `<dialog>`, so focus trapping, background inertness and the Esc
 * key come from the browser. This element only opens it, closes it on a backdrop click,
 * and keeps `aria-expanded` on the trigger in sync with the dialog's own `close` event —
 * which fires for the button, Esc and the backdrop alike, so the state can never desync.
 */
if (!customElements.get('lp-pdp-redo')) {
  customElements.define(
    'lp-pdp-redo',
    class LpPdpRedo extends HTMLElement {
      connectedCallback() {
        this.trigger?.addEventListener('click', this.open);
        this.closeButton?.addEventListener('click', this.close);
        this.modal?.addEventListener('click', this.onModalClick);
        this.modal?.addEventListener('close', this.onModalClose);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.open);
        this.closeButton?.removeEventListener('click', this.close);
        this.modal?.removeEventListener('click', this.onModalClick);
        this.modal?.removeEventListener('close', this.onModalClose);
      }

      /** @returns {HTMLButtonElement | null} */
      get trigger() {
        return this.querySelector('[data-redo-trigger]');
      }

      /** @returns {HTMLDialogElement | null} */
      get modal() {
        return this.querySelector('[data-redo-modal]');
      }

      /** @returns {HTMLButtonElement | null} */
      get closeButton() {
        return this.querySelector('[data-redo-close]');
      }

      open = () => {
        this.modal?.showModal();
        this.trigger?.setAttribute('aria-expanded', 'true');
      };

      close = () => {
        this.modal?.close();
      };

      /**
       * A click on the backdrop reports the dialog itself as the target; a click on the
       * panel reports one of its descendants.
       * @param {MouseEvent} event
       */
      onModalClick = (event) => {
        if (event.target !== this.modal) return;
        this.close();
      };

      onModalClose = () => {
        this.trigger?.setAttribute('aria-expanded', 'false');
      };
    }
  );
}
